// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { BrowserApi } from "@lib/browser/BrowserApi";
import { ChromeBrowser } from "@lib/browser/ChromeBrowser";
import { FirefoxBrowser } from "@lib/browser/FirefoxBrowser";

declare var chrome: unknown;
declare var browser: unknown;

let api: BrowserApi;
if (typeof browser !== "undefined" && Object.getPrototypeOf(browser) === Object.prototype)
  api = FirefoxBrowser;
else if (typeof chrome !== "undefined" && Object.getPrototypeOf(chrome) === Object.prototype)
  api = ChromeBrowser;
else
  throw new Error("Browser extension API is not supported.");

/**
 * Exposes the Browser Extension API in a browser-independent way.
 */
export const Browser = api;